import { Button, Divider, Paper, Stack, Typography } from "@mui/material";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import NearbyErrorRoundedIcon from "@mui/icons-material/NearbyErrorRounded";
import WestIcon from "@mui/icons-material/West";
import { useNavigate } from "react-router";

export const ErrorView = () => {
  const navigate = useNavigate();

  return (
    <Paper sx={{ p: 1, height: "100vh", width: "100vw" }}>
      <Stack
        sx={{
          height: "100%",
          width: "100%",
        }}
        alignItems="center"
        justifyContent="center"
        gap={2}
      >
        <Stack
          direction="row"
          alignContent={"center"}
          alignItems={"center"}
          justifyContent={"center"}
          width="100%"
        >
          <PrecisionManufacturingIcon
            sx={{
              width: "30%",
              maxWidth: "200px",
              height: "auto",
            }}
            color="disabled"
          />
          <NearbyErrorRoundedIcon
            sx={{
              width: "20%",
              maxWidth: "100px",
              height: "auto",
            }}
            color="disabled"
          />
        </Stack>
        <Typography
          variant="h4"
          sx={{ textAlign: "center", mt: 2 }}
          fontWeight="bold"
        >
          Uh oh!
        </Typography>
        <Divider
          orientation="horizontal"
          sx={{
            width: "100%",
            maxWidth: "580px",
          }}
        />
        <Typography
          variant="body1"
          sx={{ textAlign: "center", mt: 2, maxWidth: "500px", mx: "auto" }}
        >
          An error has occurred. If the problem persists, contact support.
        </Typography>
        <Button
          sx={{ mt: 3.5 }}
          onClick={() => navigate(-1)}
          variant="outlined"
          startIcon={<WestIcon />}
        >
          Go Back
        </Button>
      </Stack>
    </Paper>
  );
};
